import postWsController from './post-ws-controller';
import commentWsController from './comment-ws-controller';

export default {
  postWsController,
  commentWsController,
};
